export default {
  elemetn: null,
  title: '',
  body: '',
  action: () => {}
}
